import type { ActionReturn } from "svelte/action";
import type { Writable } from "svelte/store";

interface InViewportOptions {
	store?: Writable<boolean>;
	onIntersect?(): void;
	rootMargin?: string;
}

export function inViewport(element: HTMLElement, options?: InViewportOptions): ActionReturn {
	const observer = new IntersectionObserver(
		(entries) => {
			const [entry] = entries;
			const isIntersecting = entry?.isIntersecting ?? false;
			options?.store?.set(isIntersecting);
			if (isIntersecting) {
				options?.onIntersect?.();
			}
		},
		{
			rootMargin: options?.rootMargin ?? `-150px 0px -150px 0px`,
		},
	);

	observer.observe(element);

	return {
		destroy(): void {
			observer.disconnect();
		},
	};
}
